import {Encrypt, Decrypt} from '@/services/Crypt/AES'
    export function LoginSet(response:any)
    {
        
        localStorage.clear()
        localStorage.setItem('d1',Encrypt(response.email))
        localStorage.setItem('d2',Encrypt(response.token))
        
    }
    export function PermSet(response:any)
    {
        const arr:any[]=[];
        const keydata: any[]=Object.keys(response)
        console.log(keydata)

        for (const key in keydata)
        {
            console.log(key)

            if(response[keydata[key]]==true)
            {
                arr.push(keydata[key])
            }
        }
        console.log(arr.toString())
        //console.log(arr.toString().)

        localStorage.setItem('d3',Encrypt(arr.toString()))
        
        //localStorage.setItem('d3',Encrypt(response.email))
        //localStorage.setItem('d2',Encrypt(response.token))
        
    }
    export function PermGet() {
        if(localStorage.getItem('d3')!=null)
        {
        const data:string = Decrypt(localStorage.getItem('d3'))
        const arr=data.split(',')
        return arr;
        }
        else{
            return null;
        }
    }
